import { useTranslation } from 'react-i18next';
import { Page } from '@web/components/page';
import { withServerProps } from '@web/library/with-server-props';
import { BuyingADogScreen, BuyingADogScreenProps } from 'shared/screens/buying-a-dog';
import { getCountryName } from 'shared/library/i18n/country-name';

export default function BuyingADog(props: BuyingADogScreenProps) {
  const { t } = useTranslation('screens');
  const listingCountryName = getCountryName(t, props.listingCountry) ?? props.listingCountry;

  return (
    <Page
      {...props}
      register={(seo) =>
        seo.forPage(
          t('buying_a_dog.title', { country: listingCountryName }),
          t('buying_a_dog.description', { country: listingCountryName }),
        )
      }
    >
      <BuyingADogScreen {...props} />
    </Page>
  );
}

export const getServerSideProps = withServerProps(BuyingADogScreen.pageBuilder);
